import { UNSET_USER } from "../constants";

export default () => ({
  type: UNSET_USER,
});
